import '../index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const defaultIcon = new URL('../../../assets/default-icon.png', import.meta.url).href;
const ensureFavicon = (): void => {
  const existing = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (existing) {
    existing.href = defaultIcon;
    return;
  }
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = defaultIcon;
  document.head.appendChild(link);
};

ensureFavicon();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
